
import { dashboardHDLR } from "../../../handlers"
import { getColor } from "../handler"
import { TIME } from "../../../services/util"

const placeholderData = [
    { month: 'January', value: 0 },
    { month: 'February', value: 0 },
    { month: 'March', value: 0 },
    { month: 'April', value: 0 },
    { month: 'May', value: 0 },
    { month: 'June', value: 0 },
    { month: 'July', value: 0 },
    { month: 'August', value: 0 },
    { month: 'September', value: 0 },
    { month: 'October', value: 0 },
    { month: 'November', value: 0 },
    { month: 'December', value: 0 },
];

const isDataEmpty = (data) => data?.length === 0;

export const dailyChart = (data) => {

    const displayData = 
    isDataEmpty(data) ? 
    [{ date: TIME.currentTime(), value: 0, category: '' }] 
    : data;
            
        return {
        data: displayData,
        xField: 'date',
        yField: 'value',
        point: {
            shapeField: 'circle',
            size: (value) => value === 0 ? 0 : 4,
            style: {
                fill: 'white',
                lineWidth: 1
            }
        },
        legend: false,
        colorField: 'category',
        scale: {
            color: { 
                domain: ['Requested Amount', 'Net Disbursement Amount', 'Admin Fees', 'Total Applications', 'Total Applicants', 'New Applicants'],
                range: ["#211572", "#821CB1", "#5454C5", "#D10707", "#FF0000", "#FFA800"] 
            },
        },
        tooltip: { 
            title: (d) => d.date,
            items: [{ channel: 'y' }],    
        },
}};

export const employeeChart = (data) => {

    const displayData = isDataEmpty(data) ? [{ age: '0', reqAmount: '0', gender: 'Female', count: '0' }, { age: '0', reqAmount: '0', gender: 'Male', count: '1' }] : data;
        
       return {
        data: displayData,
        xField: 'age',
        yField: 'reqAmount',
        sizeField: 'count',
        colorField: 'gender',
        shapeField: 'point',
        scale: {
            size: { type: 'log', range: [0, 20] },
            color: { range: ["#FF6363", "#506DEE"] },
        },
        style: { fillOpacity: 0.3, lineWidth: 1 },
        tooltip: (item) => {return { origin: item }},
        interaction: {
            tooltip: {
            render: (e, { title, items }) => {
                return (
                <div key={title}>
                    <div style={{ margin: 0, display: 'flex', justifyContent: 'space-between' }}>
                        <div>
                            <b>Gender</b>
                        </div>
                        <div>
                            <span
                                style={{
                                    display: 'inline-block',
                                    width: 8,
                                    height: 8,
                                    borderRadius: '50%',
                                    backgroundColor: title === 'Male' ? '#506DEE' : '#FF6363',
                                    opacity: 0.3,
                                    marginRight: 6,
                                }}
                            ></span>
                            <b>{title}</b>
                        </div>
                    </div>
    
                    {items.map((item) => {
                    const { origin } = item;
                    const age = origin['age']
                    const count = origin['count']
                    const reqAmount = origin['reqAmount']
                    return (
                        <div>
                            <div>
                                {age && 
                                    <div style={{ margin: 0, display: 'flex', justifyContent: 'space-between' }}>
                                        <b>Age</b>
                                        <b style={{marginLeft: "10px"}}>{age}</b>
                                    </div>
                                }
                                {reqAmount && 
                                    <div style={{ margin: 0, display: 'flex', justifyContent: 'space-between' }}>
                                        <b>Requested Amount</b>
                                        <b style={{marginLeft: "10px"}}>{reqAmount}</b>
                                    </div>
                                }
                                {count && 
                                    <div style={{ margin: 0, display: 'flex', justifyContent: 'space-between' }}>
                                        <b>Count</b>
                                        <b style={{marginLeft: "10px"}}>{count}</b>
                                    </div>
                                }
                            </div>
                        </div>
                    );
                    })}
                </div>
                );
            },
            },
        },
}};

export const monthlyChart = (groupedData, option) => {
    const data = groupedData?.[option] || []
    // if empty data
    const displayData = isDataEmpty(data)
      ? placeholderData : data
  
    return {
      data: displayData,
      xField: 'month',
      yField: 'value',
      label: {
        text: (d) => {
            return (d.value === 0 ? "" : d.value)}, // just showing the label
        textBaseline: 'bottom',
        style: {
          fill: getColor(option),
        },
      },
      style: {
        maxWidth: 10,
        fill: getColor(option),
      },
      conversionTag: data?.length > 1 ? {
        size: 20,
        spacing: 4,
        text: {
          formatter: (prev, next) => {
            if (prev === 0 && next > 0) {
                return `${(next * 100).toFixed(1)}%`;
              } else if (next === 0 && prev > 0) {
                return `100.0%`;
              } else if (prev > 0 && next > 0) {
                const percentageChange = ((next - prev) / prev) * 100;
                return `${percentageChange.toFixed(1)}%`;
              } else {
                return "0%";
              }
            }
        }
        } : undefined,
    };
  };